<template>
  <div class="course">
    <div v-if="params.item.summary.length" class="course__sticker-wrp">
      <div
        class="course__sticker !bg-default"
        :class="{ 'course__sticker--active': isActiveContent }"
        @click="isActiveContent = !isActiveContent"
      >
        <svg class="icon icon_color_white">
          <use xlink:href="/img/sprites/icons-sprite.svg#icon-info"></use>
        </svg>
      </div>
    </div>
    <div style="display: flex">
      <div class="course__aside">
        <i v-if="isPaidCourse" class="course__icon icon_bg_peach">
          <svg class="icon icon_size_l icon_color_peach">
            <use xlink:href="/img/sprites/icons-sprite.svg#icon-rub"></use>
          </svg>
        </i>
        <i v-else class="course__icon !bg-default/10">
          <svg class="icon !fill-default" :class="`status_color_${isCourseActive.type}`">
            <use xlink:href="/img/sprites/icons-sprite.svg#icon-course"></use>
          </svg>
        </i>
        <btn-wrapper type= 'div' class = 'course__icon cursor-pointer' @click="toggleStar">
          <svg class="icon icon_color_light-gray" :class="{ course__icon_active: params.item.isfavourite }">
            <use xlink:href="/img/sprites/icons-sprite.svg#icon-star"></use>
          </svg>
        </btn-wrapper>
    </div>
    <div class="course__inner">
      <div class="course__top">
        <div class="w-full flex items-center justify-between">
          <div class="flex-1 pr-4 cursor-pointer">
            <h4 class="font-bold max-sm:text-base" data-testid="categories-courses-header" @click="goToCoursePage(params.item)">
              {{ params.item.fullname }}
            </h4>
            <a class="text-sm text-gray-400 hover:text-default" target="_blank" :href="'/courses-list/'+ params.item?.categoryid">
              {{params.item?.categoryname}}
            </a>
          </div>
        </div>
        <i v-if="isPaidCourse" class="course__icon icon_bg_peach course__icon_tablet-off">
          <svg class="icon icon_size_l icon_color_peach">
            <use xlink:href="/img/sprites/icons-sprite.svg#icon-rub"></use>
          </svg>
        </i>
      </div>
      <Transition name="fade">
        <div class="course__content">
          <div class="course__info" v-if="isActiveContent || !params.item.summary.length">
            <div class="course__state">
              <Status class="course__status" :params="isCourseActive" />
            </div>

            <div v-if="params.item?.startdate" class="course__start item">{{ startDate(params.item) }}</div>
          </div>
          <p
            v-if="params.item.summary.length"
            class="text course__text"
            :class="{ 'text-dimmed': !isActiveContent }"
            v-html="formatImages(params.item.summary)"
            @click="isActiveContent = true"
          ></p>
          <div>
            <Teachers
              class="course__teachers"
              :courseid="params.item.id"
              v-if="isActiveContent || !params.item.summary.length"
            />
          </div>
        </div>
      </Transition>
      <div class="course__bottom">
        <btn-wrapper
          v-if="canEnroll"
          @click="enrollToCourse"
          :params="{
            class:
              'button button_bg_blue button_text-color_white button_round_medium course__link',
            type: 'button',
            path: '',
            title: canEnroll
              ? t('courseComp.enrollBtn.canEnroll')
              : t('courseComp.enrollBtn.cantEnroll'),
          }"
        />
        <btn-wrapper
          @click="toggleStar"
          :params="{
            class: 'course__icon  course__icon_star course__icon_tablet-off',
            type: 'div',
            isSlotIsset: true,
          }"
        >
          <svg
            class="icon icon_color_light-gray"
            :class="{ course__icon_active: params.item.isfavourite }"
          >
            <use xlink:href="/img/sprites/icons-sprite.svg#icon-star"></use>
          </svg>
        </btn-wrapper>
      </div>
    </div>
    </div>
    <ModalBase @close="isShowModal = false" v-if="isShowModal">
      <div class="course__modal">
        <h3>{{ t('courseComp.registration') }} : {{ params.item.fullname }}</h3>
        <label class="course__modal-input">
          <input v-model="password" type="password" />
        </label>
        <div class="course__modal-btns">
          <button @click="enrollToCourse" class="course__modal-btn">
            {{ t('courseComp.enrollBtn.canEnroll')}}
          </button>
          <button class="course__modal-cancel" @click="isShowModal = false">
            {{ t('courseComp.enrollBtn.cancel')}}
          </button>
        </div>
      </div>
    </ModalBase>
  </div>
</template>

<script>
import Status from "./components/Status.vue";
import Teachers from "../teachers/index.vue";
import { computed } from "vue";
import { formatDate } from "@/script";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { formatImages } from "@/script";
import ModalBase from "@/components/UI/modal/modalBase.vue";

export default {
  name: "Course",

  props: {
    params: {
      type: Object,
    },
  },

  data: () => ({
    isActiveContent: false,
    isActiveFavorite: false,
  }),

  setup(props, { emit }) {
    const router = useRouter();
    const store = useStore();
    const { t } = useI18n();
    const route = useRoute();
    const password = ref("");
    const isShowModal = ref(false);
    const user = computed(() => store.getters.user);
    const goToCoursePage = (item) => {
      if (!user.value) {
        // store.commit("setUrlToNavAfterLogin", route.fullPath);
        router.push(`/viewcourse/${item.id}`);
        return;
      }
      router.push(`/course/${item.id}`);
    };

    const enrollToCourse = () => {
      if (!user.value) {
        store.commit("setUrlToNavAfterLogin", route.fullPath);
        router.push("/auth");
        return;
      }
      store
        .dispatch("enrollToCourse", {
          id: props.params.item.id,
          password: password.value,
        })
        .then((res) => {
          if (res.status) {
            isShowModal.value = false;
            password.value = "";
            emit("enroll", props.params.item);
          } else {
            res.warnings.forEach((el) => {
              if ([2, 3, 4].includes(+el.warningcode)) {
                isShowModal.value = true;
              }
            });
          }
        });
    };


    const canEnroll = computed(() => {
      return (
        props.params.item.enrollmentmethods?.find((el) => el === "self") &&
        !props.params.item.enrolled
      );
    });

    const toggleStar = () => {
      store
        .dispatch("toggleCourseStar", {
          id: props.params.item.id,
          state: props.params.item.isfavourite == true ? 0 : 1,
        })
        .then((res) => {
          if (!res.warnings.length) {
            emit("change", props.params.item);
          }
        });
    };

    const isCourseActive = computed(() => {
      const now = new Date().getTime();
      if (props.params.item.enddate === 0) {
        return {
          type: "open",
        };
      }
      return props.params.item.enddate * 1000 < now
        ? { type: "close" }
        : { type: "open" };
    });

    const startDate = computed(() => {
      return (payload) => {
        //eslint-disable-next-line
        if (!!payload?.startdate)
          return `${t("courseComp.start")} ${formatDate(
            payload?.startdate
          )}`;
      };
    });

    const isPaidCourse = computed(() => {
      return !!props.params.item.customfields?.find(el => (el.shortname === 'ispayedcourse' && el.valueraw === 1))
    });

    return {
      goToCoursePage,
      startDate,
      toggleStar,
      isCourseActive,
      canEnroll,
      enrollToCourse,
      t,
      isShowModal,
      password,
      formatImages,
      isPaidCourse
    };
  },

  components: {
    ModalBase,
    Status,
    Teachers,
  },
};
</script>

<style lang="scss" scoped>
@import "./scss/course.scss";

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
  max-height: 700px;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  max-height: 0;
}
</style>
